import React, { useState } from 'react';
import { ArrowLeft, MessageSquareText, ShieldCheck, Smartphone } from 'lucide-react';
import ConversationList from './ConversationList';
import ConversationThread from './ConversationThread';

const STORE_FILTERS = [
  ['all', 'Activas'],
  ['unread', 'Sin leer'],
  ['delivery_issue', 'Incidencias'],
];

export default function StoreCommunicationInbox({ userId, setActiveComponent }) {
  const [selected, setSelected] = useState(null);

  return (
    <div className="flex h-screen w-screen flex-col overflow-hidden bg-slate-100">
      <div className="flex items-center gap-3 border-b border-slate-200 bg-white px-3 py-3 sm:px-4">
        <button
          onClick={() => setActiveComponent?.('Options')}
          className="inline-flex flex-shrink-0 items-center gap-2 rounded-lg bg-slate-100 px-3 py-2 text-sm font-bold text-slate-700 hover:bg-slate-200"
        >
          <ArrowLeft className="h-4 w-4" />
          Menú
        </button>
        <div className="min-w-0">
          <h1 className="truncate text-base font-extrabold text-slate-950 font-montserrat sm:text-lg">Chat Fast Max</h1>
          <p className="line-clamp-2 text-xs text-slate-500">
            Comunicación interna por entrega con Fast Max, motorizado y proveedor.
          </p>
        </div>
      </div>

      <div className="flex min-h-0 flex-1 overflow-hidden">
        <div className={`${selected ? 'hidden lg:block' : 'block'} w-full lg:w-[380px] xl:w-[430px]`}>
          <ConversationList
            scope="store"
            userId={userId}
            selectedConversationId={selected?.id}
            onSelect={setSelected}
            title="Mis entregas activas"
            subtitle="Hilos internos + historial WhatsApp relacionado"
            filterOptions={STORE_FILTERS}
            limit={25}
            searchPlaceholder="Buscar ID, cliente, producto, distrito o mensaje"
          />
        </div>
        <div className={`${selected ? 'flex' : 'hidden lg:flex'} min-w-0 flex-1 flex-col gap-2 p-2 sm:gap-3 sm:p-4`}>
          {selected && (
            <button
              type="button"
              onClick={() => setSelected(null)}
              className="inline-flex items-center gap-2 rounded-lg bg-white px-3 py-2 text-sm font-bold text-slate-700 shadow-sm ring-1 ring-slate-200 hover:bg-slate-50 lg:hidden"
            >
              <ArrowLeft className="h-4 w-4" />
              Conversaciones
            </button>
          )}
          {!selected && <div className="hidden gap-3 lg:grid lg:grid-cols-3">
            <div className="rounded-xl border border-slate-200 bg-white p-3 text-xs text-slate-600 shadow-sm">
              <div className="mb-1 flex items-center gap-2 font-bold text-slate-900">
                <MessageSquareText className="h-4 w-4 text-[#B1336E]" />
                Chat interno
              </div>
              Tu mensaje queda conectado a la entrega y visible para Fast Max y participantes operativos.
            </div>
            <div className="rounded-xl border border-slate-200 bg-white p-3 text-xs text-slate-600 shadow-sm">
              <div className="mb-1 flex items-center gap-2 font-bold text-slate-900">
                <Smartphone className="h-4 w-4 text-emerald-600" />
                WhatsApp externo
              </div>
              También puedes escribir al WhatsApp del cliente final cuando la ventana de 24h esté abierta.
            </div>
            <div className="rounded-xl border border-slate-200 bg-white p-3 text-xs text-slate-600 shadow-sm">
              <div className="mb-1 flex items-center gap-2 font-bold text-slate-900">
                <ShieldCheck className="h-4 w-4 text-sky-600" />
                Trazabilidad
              </div>
              Emergencias, notas y coordinación quedan auditables para resolver la entrega más rápido.
            </div>
          </div>}

          <ConversationThread
            conversationId={selected?.id}
            currentUserId={userId}
            currentUserType="store"
            className="min-h-0 flex-1"
            allowNotes={false}
            inputPlaceholder="Escribe al hilo interno de esta entrega..."
            inputHelperText="Mensaje interno: Fast Max y participantes de la entrega podrán verlo. Cambia a WhatsApp cliente para escribir al cliente final."
            enableFinalCustomerWhatsApp
            enableDeliverySlotSelection
            showDeliveryContext
          />
        </div>
      </div>
    </div>
  );
}
